/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.5.0-nightly.2026.7.19",
    versionName: "0.5.0-nightly.2026.7.19",
    versionChannel: "nightly",
    buildDate: "2026-07-19T00:26:41.233Z",
    commitHash: "c027f9857ad566f899692c15e71fa133c0fdd54a",
};
